import styled from 'styled-components';

export const FeedbackContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  overflow: auto;
`;

export const FeedbackCard = styled.div`
  width: 100%;
  max-width: 560px;
  margin: auto;
  padding: 32px;
  box-sizing: border-box;
  border-radius: 28px;
  text-align: center;
  background: ${(p) => p.theme.colors.surface};
  color: ${(p) => p.theme.colors.onSurface};

  > p {
    margin: 0 0 24px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
`;
